module.exports = "/_next/static/images/036c49281def885fd70e13ca5694ca27-kpmg.png";